module.exports = __webpack_public_path__ + "img/pk.e5c80180.svg";